/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ShivaWebSecuredConfiguration {
  rootUrl: string = 'http://localhost:8090/web';
}

/**
 * Parameters for `ShivaWebSecuredModule.forRoot()`
 */
export interface ShivaWebSecuredConfigurationParams {
  rootUrl?: string;
}
